export function localhostRoute() {
  // return {
  //   label: "https://label.test.ratify.global",
  //   // label: "http://localhost:3000",
  //   viewer: "https://label.test.ratify.global/viewer",
  //   comms: "https://comms.test.ratify.global"
  // };
  return {
    label: "https://label.dev.ratify.global",
    // label: "http://localhost:3000",
    viewer: "https://label.dev.ratify.global/viewer",
    comms: "https://comms.dev.ratify.global"
  };
}
